import {Component, OnInit} from '@angular/core';

import {ComplianceArea} from '../../_models/index';

import {Role} from '../../helpers/index';

import {Bulletin} from "../../_models/bulletin";
import {MatDialog, MatDialogConfig, MatDialogRef} from '@angular/material/dialog';
import {EditBulletinComponent} from "../editBulletin";
import {CreateBulletinComponent} from "../createBulletin";
import {BulletinService} from "../../_services/bulletin.service";

@Component({
    standalone: false,
  selector: 'control-item-component',
  templateUrl: 'bulletins.component.html',
  styleUrls: ['./bulletins.component.scss'],
})

export class BulletinsComponent implements OnInit {
  loading = false;
  bulletin: Bulletin;
  complianceAreas: ComplianceArea[];
  dialogCreateBulletinRef: MatDialogRef<CreateBulletinComponent> | null;
  dialogEditBulletinRef: MatDialogRef<EditBulletinComponent> | null;
  bulletins: any[];
  canManageBulletins: boolean;

  constructor(
    public dialog: MatDialog,
    public bulletinService: BulletinService
    ) {
  }

  ngOnInit() {
    const currentUser = JSON.parse(sessionStorage.getItem('currentUser'));

    this.loadBulletins();
    this.canManageBulletins = (currentUser.role & Role.Manager) != 0
      || (currentUser.role & Role.AdvisorLead) != 0
    ||(currentUser.role & Role.PrimaryManager) != 0
      || (currentUser.role & Role.PrimaryAdvisorLead | Role.PlatformSupport) != 0;
  }

  onClose(): void {
    this.loadBulletins();
  }


  editBulletin(bulletin: Bulletin) {
    let config: MatDialogConfig = {
      panelClass: 'custom-overlay-pane-class',
      width: '60%',
      //height: '600px',
      data: {
        bulletin: bulletin
      }
    };

    this.dialogEditBulletinRef = this.dialog.open(EditBulletinComponent, config);
    this.dialogEditBulletinRef.afterClosed().subscribe((result: any) => {
      this.loadBulletins();
    });
  }

  createBulletin() {
    let config: MatDialogConfig = {
      panelClass: 'custom-overlay-pane-class',
      width: '60%',
      //height: '600px',
    };

    this.dialogCreateBulletinRef = this.dialog.open(CreateBulletinComponent, config);
    this.dialogCreateBulletinRef.afterClosed().subscribe((result: any) => {
      this.loadBulletins();
    });
  }

  loadBulletins() {
    this.bulletinService.getAll().subscribe(data => {
      this.bulletins = data;
    });
  }

  deleteBulletin(id) {
    this.bulletinService.delete(id).subscribe(data => {
      this.loadBulletins();
    });
  }
}
